module.exports = __webpack_public_path__ + "static/media/Download.43fced7d.svg";